import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, provide, watch } from "vue";
import Pay from "@/views/sellstock/transaction/Pay";
import CreateOrder from "@/views/sellstock/transaction/CreateOrder";
import { useRoute, useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isDialogVisiblePay = ref(false);
const openPaymentDialog = () => {
  isDialogVisiblePay.value = true;
};

const isDialogVisibleCreateOrder = ref(false);
const createOrderDialog = ref<any>(null);
const openCreateOrderDialog = (data?: any) => {
  if (data && createOrderDialog.value) {
    createOrderDialog.value.initData(data);
  }
  isDialogVisibleCreateOrder.value = true;
};

const componentKey = ref(0);

const reloadComponent = (item: any) => {
  if (router.currentRoute.value.fullPath == item.to) {
    componentKey.value += 1;
  }
};

provide("reloadComponent", reloadComponent);
provide("openPaymentDialog", () => {
  isDialogVisiblePay.value = true;
});

provide("openCreateOrderDialog", openCreateOrderDialog);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", { key: componentKey.value }, [
    _createVNode(_unref(Pay), {
      ref: "payDialog",
      modelValue: isDialogVisiblePay.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDialogVisiblePay).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_unref(CreateOrder), {
      ref_key: "createOrderDialog",
      ref: createOrderDialog,
      modelValue: isDialogVisibleCreateOrder.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isDialogVisibleCreateOrder).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_router_view)
  ]))
}
}

})